import React from 'react';
import { DashboardNavHeaderStatus } from './DashboardNavHeaderStatus';
import { PageHeaderWrapper } from '../../../../app/header/PageHeaderWrapper';
import {
    DashboardNavHeaderActions,
    DashboardNavHeaderActionsProps,
} from './DashboardNavHeaderActions';
import { PageHeaderProps } from '@splunk/olly-common';

type DashboardNavPageHeaderWrapperProps = Pick<PageHeaderProps, 'description' | 'navigation'> &
    Pick<
        DashboardNavHeaderActionsProps,
        | 'actions'
        | 'hasDeleteDashboardGroupCapability'
        | 'isExportEnabled'
        | 'groupActions'
        | 'model'
        | 'modernDashboardsEnabled'
        | 'onTrackClick'
    > & {
        groupEnabled?: boolean;
        showStatus?: boolean;
    };

export const DashboardNavPageHeaderWrapper = ({
    actions,
    description,
    hasDeleteDashboardGroupCapability,
    isExportEnabled,
    groupActions,
    groupEnabled,
    model,
    modernDashboardsEnabled,
    navigation,
    onTrackClick,
    showStatus,
}: DashboardNavPageHeaderWrapperProps): React.JSX.Element => {
    return (
        <PageHeaderWrapper
            description={description}
            navigation={navigation}
            rightContent={
                actions !== undefined && groupActions !== undefined ? (
                    <DashboardNavHeaderActions
                        actions={actions}
                        groupActions={groupActions}
                        groupEnabled={groupEnabled}
                        hasDeleteDashboardGroupCapability={hasDeleteDashboardGroupCapability}
                        isExportEnabled={isExportEnabled}
                        model={model}
                        modernDashboardsEnabled={modernDashboardsEnabled}
                        onTrackClick={onTrackClick}
                    />
                ) : null
            }
            titleContent={showStatus ? <DashboardNavHeaderStatus /> : null}
        />
    );
};
